import { UserRound, Compass, Workflow, Eye, Award } from "lucide-react";
import { Reveal, Eyebrow } from "./Shared";
import { WHY } from "@/lib/site";

const ICONS = [UserRound, Compass, Workflow, Eye, Award];

export default function WhyNexfold() {
  return (
    <section className="bg-[#F9FAFB] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <Eyebrow>Why Nexfold</Eyebrow>
          <h2 className="font-display mt-6 max-w-3xl text-4xl md:text-5xl font-bold tracking-tight leading-[1.1] text-[#0B1F3A]">
            A partner invested in your long-term outcome.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-6">
          {WHY.map((item, i) => {
            const Icon = ICONS[i];
            const isTop = i < 2;
            return (
              <Reveal
                key={item.title}
                delay={0.05 * i}
                className={isTop ? "lg:col-span-3" : "lg:col-span-2"}
              >
                <div
                  data-testid={`why-card-${i}`}
                  className="group h-full rounded-2xl border border-[#0B1F3A]/8 bg-white p-8 md:p-9 shadow-[0_8px_30px_rgba(11,31,58,0.04)] transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_rgba(11,31,58,0.10)]"
                >
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#0B1F3A] transition-colors duration-500 group-hover:bg-[#C8A75D]">
                    <Icon className="h-5 w-5 text-[#C8A75D] transition-colors duration-500 group-hover:text-[#0B1F3A]" />
                  </div>
                  <h3 className="font-display mt-6 text-xl font-bold tracking-tight text-[#0B1F3A]">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-[#4B5563]">
                    {item.body}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
